<template>
   <div class="chartsWarp" style="padding-top:30px">
    <DomainInput style="margin-bottom:30px" @setDomain="setDomain"></DomainInput>
    <div class="chartsList">
      <LineChart name="翻译字数" id="sizeChart" :colorStops="{start:'#CFBA45',end:'white'}" :smooth="true" type="size" :domainCode="domainCode">
      </LineChart>
      <LineChart name="翻译速度" id="speedChart" :colorStops="{start:'#3486FB',end:'white'}" :smooth="true" type="speed" :domainCode="domainCode">
      </LineChart>
      <LineChart name="流畅度" id="fluencyChart" type="fluency" :domainCode="domainCode"></LineChart>
      <LineChart name="准确度" id="accuracyChart" type="accuracy" :domainCode="domainCode"></LineChart>
    </div>
  </div>
</template>

<script>
import LineChart from "@/common/Statistics/InterpreterStatistics/echarts/LineChart";
import DomainInput from "@/common/Statistics/InterpreterStatistics/DomainInput";
export default {
  props: {

  },
  data() {
    return {
       domainCode:""
    };
  },
  components: {
    DomainInput,
    LineChart
  },
  created() {

  },
  mounted() {

  },
  methods: {
    setDomain(data) {
      this.domainCode = data;
      this.$emit('setDomain', data)
    }
  },
};
</script>

<style lang="less" scoped>
.chartsList {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-right: 30px;
}
</style>
